<template>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"><b>
            <!-- {{ id ? "Update" : "Add" }} -->
              Assign Classroom</b></p>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field label="User">
                <b-select placeholder="User" v-model="assign.type" expanded>
                    <option value="T" >Teacher</option>
                    <option value="S" >Student</option>
                </b-select>
            </b-field>
          </div>
          <div class="column is-12">
            <table class="table is-fullwidth" :hoverable="true">
                <tr>
                    <th>Email</th>
                    <th>Action</th>
                </tr>
                <tr v-for="(_,userIndex) in assign.users" :key="`new-user-${userIndex}`">
                    <td>
                        <b-input
                            type="text"
                            v-model="assign.users[userIndex]"
                            required
                        ></b-input>
                    </td>
                    <td>
                        <div class="buttons is-right" style="display:block">
                            <b-button class="button is-small is-danger" @click="removeRow" type="button">
                                <b-icon
                                    icon="minus"
                                    size="is-small">
                                </b-icon>
                            </b-button>
                        </div>
                    </td>
                </tr>
            </table>
            <div class="buttons is-right" style="display:block">
                <b-button @click="addRow" class="button is-small is-success" type="button">
                    <b-icon
                        icon="plus"
                        size="is-small">
                    </b-icon>
                </b-button>
            </div>
          </div>
          <div class="column is-12">
            <b-button
              @click="proceed()"
              class="btn-center"
              type="is-primary"
              >
              <!-- {{ id ? "Update" : "Create" }}  -->
              Assign Classroom</b-button
            >
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Close
        </button>
      </footer>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: "assign-classroom",
    components : {
    },
    props: {
      id:{
        type:String,
      }
    },
    data() {
      return {
        assign:{
            type:"",
            users:[""],
        },
      }
    },
    computed: {
      ...mapGetters(["getTeacherToken", 
    //   "fetchPODetails"
    ]),
    },
    methods: {
    
        ...mapActions([
            // "updatePO",
            "assignClassroom"
        ]),
        addRow () {
            this.assign.users.push("");
        },
        removeRow(){
            this.assign.users.splice(this.assign.users.length-1,1);
        },

        proceed() {
        // if (this.id) {
        //   //For uthispdate
        //   this.updatePO({
        //     id: .id,
        //     po: this.po,
        //     token: this.userToken,
        //   })
        //     .then(() => {
        //       this.$emit("over");
        //       this.$buefy.toast.open({
        //         message: "PO updated successfully",
        //         type: "is-success",
        //       });
        //     })
        //     .catch((err) => {
        //       this.$buefy.toast.open({
        //         message: err.response.data['msg'],
        //         type: "is-danger",
        //       });
        //     });
        // } else {
          //For new
          
          this.assign.users = this.assign.users.filter((v)=>{
            return v.length
          });

          this.assignClassroom({
            assign: this.assign,
            id: this.id,
            token: this.getTeacherToken,
          })
            .then(() => {
              this.$emit("over");
              this.$buefy.toast.open({
                message: "Classroom assigned successfully",
                type: "is-success",
              });
            })
            .catch((err) => {
              this.$buefy.toast.open({
                message: err.response.data['msg'],
                type: "is-danger",
              });
            });
        }
    //   },
    },
    watch:{
    //   fetchPODetails(new_val){
    //      for(let key in this.po){
    //           this.po[key]=new_val[key]
    //      }
    //   }
    },
    async created() {
    //   if(this.id){
    //     this.loadPODetails({id:this.id,token:this.userToken})
    //   }
    },
  };
  </script>
  <style scoped>
  .button {
    flex-direction: row;
    width: 100%;
    background: #8919e7;
    color: #fff;
    gap: 1vw;
    cursor: pointer;
    position: relative;
    text-transform: capitalize;
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
    padding: 1.2vw 5vw;
    border-radius: 1.1vw;
    font-size: 1.2vw;
  }
  .button.outline {
    border: 0.063rem solid #8919e7;
    background: #fff;
    color: #000;
  }
  </style>